export default __webpack_public_path__ + "static/simple-bubble-7b9b6cdd4cc9a48efe3e6b079557f15a.png";